const linkName = {
    PUBLIC_URL: process.env.PUBLIC_URL,

    //01_ログイン
    LOGIN: '/login',
    //02_氏名登録画面
    REGISTER_NAME: '/register_name',
    //SELECT_SCHOOL_YEAR
    SELECT_SCHOOL_YEAR: '/select_school_year',
    //03_タイトル画面
    TITLE: '/title',
    //04_条件設定画面
    CONDITION_SETTING: '/condition_setting',
    //05_献立表画面
    MENU_TABLE: '/menu_table',
    //06_栄養素画面
    NUTRIENTS_CHART: '/nutrients_chart',
    //07_セットメニュー一覧画面
    LIST_SET_MENU: '/list_set_menu',
    //09_保存データ画面
    SAVED_DATA: '/saved_data',
    //10_間食画面
    SNACKS: '/snacks',
    //11_料理選択画面
    MAIN: '/main',
    //17_栄養素シート
    NUTRIENTS_SHEET: '/nutrients_sheet',
    //18_４つの食品群シート
    FOUR_FOOD_GROUP_SHEET: '/four_food_group_sheet',
    //19_６つの基礎食品群シート
    SIX_FOOD_GROUP_SHEET: '/six_food_group_sheet',
    //20_栄養素グラフ
    NUTRIENTS_GRAPH: '/nutrients_graph',
    //22_４つの食品群グラフ
    FOUR_FOOD_GROUP_GRAPH: '/four_food_group_graph',
    //24_６つの基礎食品群グラフ
    SIX_FOOD_GROUP_GRAPH: '/six_food_group_graph',
    //26_続きから作る画面:
    CONTINUE: '/continue',
    //27_課題選択画面
    CHOICE_SUBJECT: '/choice_subject',
    //31_保存データ削除画面
    DELETE_DATA: '/delete_data',

    // Link error page
    ERROR_VALID_TIME: '/error/valid',
    ERROR_AVAILABLE: '/error/available',
    ERROR_COMMON: '/error',
    ERROR_LICENSE: '/error-license',

    /**
     * get base link
     * 
     * @param {String} _linkName 
     * @returns process.env.PUBLIC_URL + _linkName
     */
    getBaseLink(_linkName) {
        return linkName.PUBLIC_URL + _linkName;
    }
};
export default linkName;